var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4732 3.00895C23.4113 2.69624 24.3038 3.58873 23.9911 4.52684L18.1012 22.1967C17.7728 23.1818 16.4329 23.3131 15.9196 22.4103L12.2203 15.9047C11.9534 15.4353 11.5647 15.0466 11.0953 14.7797L4.58973 11.0805C3.687 10.5671 3.81824 9.22728 4.80342 8.89888L22.4732 3.00895Z",
    stroke: "#6FBE45",
    strokeWidth: 1.6875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.3906 12.6172L12.1406 14.8672",
    stroke: "#6FBE45",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendOutline);
export default __webpack_public_path__ + "static/media/send-outline.d84561fbea95b84c83fde1f020e6ba53.svg";
export { ForwardRef as ReactComponent };